// client/nodes/paragraph.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import "prosemirror-model";
import { Plugin, PluginKey } from "prosemirror-state";
import { PARAGRAPH_KEY, PARAGRAPH_SCHEMA } from "../../schema/nodes/paragraph.js";
var paragraph = () => ({
  node: {
    name: PARAGRAPH_KEY,
    schema: PARAGRAPH_SCHEMA()
  },
  plugins: (schema) => {
    return [paragraphNNodeViewPlugin];
  }
});
var ParagraphNodeView = class {
  constructor(node, view, getPos) {
    this.node = node;
    this.view = view;
    this.getPos = getPos;
    const element = document.createElement(`${DesignSystem.prefix}-text`);
    element.style.marginBlockStart = "16px";
    element.style.marginBlockEnd = "16px";
    element.style.position = "relative";
    element.contentEditable = "true";
    this.placeholder = document.createElement("span");
    this.placeholder.innerText = node.attrs.placeholder || "Hier tippen...";
    this.placeholder.style.pointerEvents = "none";
    this.placeholder.style.color = "gray";
    this.placeholder.style.position = "absolute";
    this.placeholder.style.left = "0";
    this.placeholder.style.top = "50%";
    this.placeholder.style.transform = "translateY(-50%)";
    this.placeholder.contentEditable = "false";
    const contentWrapper = document.createElement("span");
    contentWrapper.style.minHeight = "1em";
    contentWrapper.style.display = "block";
    contentWrapper.style.width = "100%";
    contentWrapper.style.outline = "none";
    contentWrapper.contentEditable = "true";
    element.appendChild(this.placeholder);
    element.appendChild(contentWrapper);
    this.dom = element;
    this.contentDOM = contentWrapper;
    this.updatePlaceholderVisibility();
    this.updateProperties();
  }
  update(node) {
    this.node = node;
    this.updatePlaceholderVisibility();
    this.updateProperties();
    return true;
  }
  updatePlaceholderVisibility() {
    const isEditorEmpty = this.view.state.doc.textContent.trim() === "";
    const isThisElementEmpty = this.node.textContent.length === 0;
    if (isEditorEmpty && isThisElementEmpty) {
      this.placeholder.style.display = "block";
    } else {
      this.placeholder.style.display = "none";
    }
  }
  updateProperties() {
    this.dom.style.textAlign = this.node.attrs.textAlign || "";
  }
  destroy() {
    this.dom.remove();
  }
};
var paragraphNodeView = (node, view, getPos) => {
  return new ParagraphNodeView(node, view, getPos);
};
var paragraphNNodeViewPlugin = new Plugin({
  key: new PluginKey("paragraph-nodeview-plugin"),
  props: {
    nodeViews: {
      [PARAGRAPH_KEY]: paragraphNodeView
    }
  }
});
export {
  paragraph
};
